import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashValues from 'lodash/fp/values';

import analytics from 'client/analytics';
import { ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK } from 'client/analytics/eventList';

import { SCREEN_ID_FAQ } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import branch from 'client/core/branch';
import MarketActions from 'client/actions/Market';

import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';

@withTransitionHook
@withScreenId(SCREEN_ID_FAQ)
@withScrollToTop
@branch({
  marketsById: ['markets', 'byId'],
})
class FaqPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'FAQ | Sunroom Rentals',
    section: 'FAQ',
    // canonical: '/',
    keywords: 'rent, home, austin, tour, apartment, sunroom faq',
    description: (
      'Frequently Asked Questions. Am I looking too early? Start touring 30-60 days ' +
      'before your lease ends. Any earlier, the rentals might already be taken ' +
      'by the time you actually need to move.'
    ),
  })

  static propTypes = {
    marketsById: PropTypes.object.isRequired,
  }

  static fetchData(match, inject) {
    return Promise.all([
      MarketActions.getList(inject),
    ]);
  }

  _onTextExpertButtonClick = () => {
    analytics.track(ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK);
  }

  render() {
    const { marketsById } = this.props;
    const marketList = lodashValues(marketsById);

    return (
      <div className='page-faq'>
        <Navbar
          leftButton={
            <SrLink
              className='link back'
              restoreScrollPosition
              redirectToLastLocation
              to='/feed'
            />
          }
        />

        <div className='faq'>
          <span className='headline'>Frequently Asked Questions</span>

          <div className='questionsContainer'>
            <span className='question'>Am I looking too early?</span>
            <span className='answer'>
              Start touring
              <span className='italics'> 30-60 days before your lease ends</span>.
              Any earlier, the rentals might already be taken by the time you actually need to move.
            </span>
            <span className='question'>Do I need to tell my landlord I'm moving?</span>
            <span className='answer'>
              Yes, landlords often
              <span className='italics'> require a 60-day notice </span>
              {
                'that you are planning to move out. If you don\'t tell your landlord, ' +
                'you may be stuck renting your current place an extra month or two.'
              }
            </span>
            <span className='question'>Is Sunroom free?</span>
            <span className='answer'>
              Yes! It's a free service for renters to find apartments, homes,
              and schedule tours. We even help you submit applications quickly!
            </span>
            <span className='question'>Why should I use Sunroom?</span>
            <span className='answer'>
              <ol>
                <li>Schedule showings any time you want.</li>
                <li>Tour homes you can't find anywhere else.</li>
                <li><span className='italics'>Get money off rent</span>, whenever possible.</li>
              </ol>
            </span>
            <span className='question'>What cities does Sunroom support?</span>
            <span className='answer'>
              Currently we support: {marketList.map(({ displayName }) => displayName).join(', ')}.
            </span>
          </div>
        </div>

        <div className='mainContainer'>

          <span className='headline'>Text us questions</span>

          <div className='teamPhoto' />

          <span className='bodyText'>
            If you have questions about a home or apartment, send us a text.
            We can call the landlord on your behalf, schedule tours, process your
            application and also provide general rental hunting tips.
            <br />
            <br />
            Feel free to link me rentals you find on other sites. We'll make sure
            you get to tour the home whenever you want!
          </span>
          <a href='sms:+15127143550' onClick={this._onTextExpertButtonClick} className='button blue'>
            <span className='prompt'>text </span>
            <span className='normal'>(512) 714-3550</span>
          </a>
        </div>
      </div>
    );
  }
}

FaqPage.displayName = 'FaqPage';

export default FaqPage;
